(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Select both the header and the announcement bar
    this.headers = document.querySelectorAll('.section-header, .announcement-bar-section');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    // Add sticky class to both header and announcement bar if necessary
    this.headers.forEach(header => {
      if (this.headerIsAlwaysSticky) {
        header.classList.add('shopify-section-header-sticky');
      }
    });

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    // Set height for each header (header and announcement bar)
    this.headers.forEach(header => {
      document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    });
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    // Observe both header and announcement bar
    this.headers.forEach(header => {
      observer.observe(header);
    });
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    // Handle sticky behavior for both header and announcement bar
    this.headers.forEach(header => {
      const headerBounds = header.getBoundingClientRect();

      if (scrollTop > this.currentScrollTop && scrollTop > headerBounds.bottom) {
        header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(() => this.hide(header));
      } else if (scrollTop < this.currentScrollTop && scrollTop > headerBounds.bottom) {
        header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(() => this.reveal(header));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(() => this.hide(header));
        }
      } else if (scrollTop <= headerBounds.top) {
        header.classList.remove('scrolled-past-header');
        requestAnimationFrame(() => this.reset(header));
      }
    });

    this.currentScrollTop = scrollTop;
  }

  hide(header) {
    if (this.headerIsAlwaysSticky) return;
    header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure(header);
    this.closeSearchModal(header);
  }

  reveal(header) {
    if (this.headerIsAlwaysSticky) return;
    header.classList.add('shopify-section-header-sticky', 'animate');
    header.classList.remove('shopify-section-header-hidden');
  }

  reset(header) {
    if (this.headerIsAlwaysSticky) return;
    header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure(header) {
    const disclosures = header.querySelectorAll('header-menu');
    disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal(header) {
    const searchModal = header.querySelector('details-modal');
    if (searchModal) searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wbc-bestsellers"] && !window.DesignMode) return;
  try {
    
  // Add your Slick slider initialization script
$(document).ready(function () {
  function initializeSlick() {
    $('.best-seller-slider').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: true, // Enable arrows (we will use custom arrows)
      prevArrow: $('.best-seller-slider-wrapper .arrows .left'), // Custom left arrow
      nextArrow: $('.best-seller-slider-wrapper .arrows .right'), // Custom right arrow
      dots: false,
      responsive: [
        {
          breakpoint: 1920,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          },
        },
        {
        breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  // Initial check and initialization
  if ($(window).width() >= 768) {
    initializeSlick();
  }

  // Add a resize listener to destroy or reinitialize the slider
  $(window).on('resize', function () {
    if ($(window).width() < 768) {
      if ($('.best-seller-slider').hasClass('slick-initialized')) {
        $('.best-seller-slider').slick('unslick'); // Destroy slick
      }
    } else {
      if (!$('.best-seller-slider').hasClass('slick-initialized')) {
        initializeSlick(); // Reinitialize slick
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
    // Get all best-seller-items in the slider wrapper
    const bestSellerItems = document.querySelectorAll('.best-seller-slider-wrapper .best-seller-slider .best-seller-item');

    // Set up MutationObserver to watch for changes within each .best-seller-item
    bestSellerItems.forEach(function (item) {
        // Watch for the addition of the .swatches container within each best-seller-item
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(function (node) {
                        // Check if the added node is the .swatches container
                        if (node.nodeType === 1 && node.matches('.swatches')) {
                            
                            // Now that .swatches is available, attach click listeners to the swatch items
                            attachSwatchClickListener(node, item);
                        }
                    });
                }
            });
        });

        // Start observing the .best-seller-item for child node additions (like .swatches)
        observer.observe(item, {
            childList: true,
            subtree: true
        });

    });

    // Function to attach click listeners to swatches inside the .swatches container
    function attachSwatchClickListener(swatchContainer, item) {
        // Select all swatch items inside the .swatches container
        swatchContainer.querySelectorAll('.swatch-view-item').forEach(function (swatchItem) {
            swatchItem.addEventListener('click', function () {
                // Get the variant ID (aria-label in this case)
                let selectedVariant = swatchItem.getAttribute('aria-label');

                // Find the corresponding variant image inside the current product item
                let variantImages = item.querySelectorAll(".variant-image[data-color='" + selectedVariant + "']");

                // Remove the 'active' class from all variant images in this product
                item.querySelectorAll(".variant-image").forEach(function (img) {
                    img.classList.remove('active');
                });

                // Add 'active' class to the matching variant image(s)
                variantImages.forEach(function (img) {
                    img.classList.add('active');
                   // Replace the primary image with the active variant image's source
                    let activeImageSrc = img.getAttribute('src');
                    let primaryImage = item.querySelector(".primary-image");
                    if (primaryImage) {
                        primaryImage.setAttribute('src', activeImageSrc);
                    }
                });
            });
        });
    }
});

// Hover image
document.querySelectorAll('.best-seller-slider-wrapper .best-seller-slider .best-seller-item').forEach(item => {
    const primaryImage = item.querySelector('.primary-image');
    const hoverImage = item.querySelector('.hover-image');

    if (primaryImage && hoverImage) {
        item.addEventListener('mouseenter', () => {
            [primaryImage.src, hoverImage.src] = [hoverImage.src, primaryImage.src];
        });

        item.addEventListener('mouseleave', () => {
            [primaryImage.src, hoverImage.src] = [hoverImage.src, primaryImage.src];
        });
    }
});





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wbc-loved-by-others"] && !window.DesignMode) return;
  try {
    
  // Add your Slick slider initialization script
  $(document).ready(function(){
    $('.loved-slider').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: true,  // Enable arrows (we will use custom arrows)
      prevArrow: $('.loved-by-others-section .arrows .left'),  // Custom left arrow
      nextArrow: $('.loved-by-others-section .arrows .right'), // Custom right arrow
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wbc-new-releases"] && !window.DesignMode) return;
  try {
    
  // Add your Slick slider initialization script
$(document).ready(function () {
  function initializeSlick() {
    $('.new-releases-slider').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: true, // Enable arrows (we will use custom arrows)
      prevArrow: $('.new-releases-slider-wrapper .arrows .left'), // Custom left arrow
      nextArrow: $('.new-releases-slider-wrapper .arrows .right'), // Custom right arrow
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  // Initial check and initialization
  if ($(window).width() >= 768) {
    initializeSlick();
  }

  // Add a resize listener to destroy or reinitialize the slider
  $(window).on('resize', function () {
    if ($(window).width() < 768) {
      if ($('.new-releases-slider').hasClass('slick-initialized')) {
        $('.new-releases-slider').slick('unslick'); // Destroy slick
      }
    } else {
      if (!$('.new-releases-slider').hasClass('slick-initialized')) {
        initializeSlick(); // Reinitialize slick
      }
    }
  });
});


 // Hover image
document.querySelectorAll('.new-releases-wrapper .new-releases-slider  .new-releases-item').forEach(item => {
    const primaryImage = item.querySelector('.primary-image');
    const hoverImage = item.querySelector('.hover-image');

    if (primaryImage && hoverImage) {
        item.addEventListener('mouseenter', () => {
            [primaryImage.src, hoverImage.src] = [hoverImage.src, primaryImage.src];
        });

        item.addEventListener('mouseleave', () => {
            [primaryImage.src, hoverImage.src] = [hoverImage.src, primaryImage.src];
        });
    }
});
 


  } catch(e) { console.error(e); }
})();
})();
